<template>
  <v-dialog
    v-model="dialog"
    width="800"
    :fullscreen="$vuetify.breakpoint.mobile"
    scrollable
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        outlined
        depressed
        color="error"
        @click.stop="dialog = !dialog"
      >
        Eliminar
      </v-btn>
    </template>
    <v-card color="background">
      <v-card-title>
        Eliminar búsqueda
        <v-spacer></v-spacer>

        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="text-subtitle-1">
        ¿Está seguro de que desea eliminar la búsqueda? Esta acción
        <span class="error--text font-weight-medium">no se puede deshacer</span
        >.
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" text @click="dialog = false">
          Cancelar
        </v-btn>

        <v-btn color="error" outlined @click="deleteSearch">
          Eliminar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DeleteSearch } from "@/graphql/mutations/searches";

export default {
  data: () => ({
    dialog: false
  }),

  props: {
    search: {
      type: Object,
      required: true
    }
  },

  methods: {
    deleteSearch() {
      this.$apollo
        .mutate({
          mutation: DeleteSearch,
          variables: {
            input: {
              id: this.search.id
            }
          }
        })
        .then(res => {
          this.$emit("reload");
          this.dialog = false;
        });
    }
  }
};
</script>
